module.exports = __webpack_public_path__ + "site/img/36.eaa81ecd.jpg";